import { NavItemPrimaryInterface } from 'app/app-layout/models/nav/nav-item-primary.model';
import { NavItemSecondaryInterface } from 'app/app-layout/models/nav/nav-item-secondary.model';

export interface NavItemsStateInterface {
  primaryNavItems?: NavItemPrimaryInterface[];
  secondaryNavItems?: { [categoryId: string]: NavItemSecondaryInterface[] };
}

export class NavItemsState implements NavItemsStateInterface {
  public primaryNavItems?: NavItemPrimaryInterface[];
  public secondaryNavItems?: { [categoryId: string]: NavItemSecondaryInterface[] };

  constructor({
    primaryNavItems = undefined,
    secondaryNavItems = undefined,
    }: NavItemsStateInterface) {
    this.primaryNavItems = primaryNavItems;
    this.secondaryNavItems = secondaryNavItems;
  }
}
